import * as React from 'react';
import PropTypes from "prop-types";

function ElementDisplay(props) {
  return (
    <div dangerouslySetInnerHTML={{__html: props.answer.content}} />
  );
}

ElementDisplay.propTypes = {
  answer: PropTypes.shape({
    id: PropTypes.number.isRequired,
    content: PropTypes.string.isRequired,
  }).isRequired,
};

export default ElementDisplay;